export enum USER_ROLES {
  SYS_ADMIN = "SYS_ADMIN",
  TENANT_ADMIN = "TENANT_ADMIN",
  CUSTOMER_ADMIN = "CUSTOMER_ADMIN",
  CUSTOMER_USER = "CUSTOMER_USER",
  TECHNICIAN = "TECHNICIAN",
}

export type UserRole = `${USER_ROLES}`;
